<template>
  <div :id="chartId" :style="{ height: chartHeight }" class="u-width-1" />
</template>

<script>
/* istanbul ignore file */
import Highcharts from 'highcharts';
import dayjs from 'dayjs';
import api from 'shared/api/westeros';

export default {
  name: 'ProductChart',
  props: {
    range: {
      type: Number,
      required: true,
    },
    product: {
      type: Object,
      required: true,
    },
    chartHeight: {
      type: String,
      default: '400px',
    },
  },
  data() {
    return {
      chart: {},
      navs: [],
      xAxis: [],
      selectedNavs: [],
      navChartConfig: {
        chart: {
          type: 'area',
        },
        title: { text: null },
        legend: { enabled: false },
        xAxis: { categories: [] },
        yAxis: { title: { enabled: false } },
        series: [
          {
            name: 'Harga NAB/Unit',
            data: [],
            dataGrouping: { enabled: false },
            states: { hover: { lineWidth: 1.5 } },
          },
        ],
        rangeSelector: { enabled: false },
        navigator: {
          maskFill: 'rgba(226,107,141,.1)',
          series: {
            color: '#2DBFAB',
            fillColor: '#fff',
          },
        },
        plotOptions: {
          series: {
            color: '#2DBFAB',
            lineColor: '#198B80',
          },
          area: {
            fillOpacity: 0.3,
          },
        },
        tooltip: {
          backgroundColor: '#000',
          borderColor: '#000',
          style: {
            color: '#fff',
            whiteSpace: 'normal',
            width: '275px',
          },
        },
        credits: { enabled: false },
      },
    };
  },
  computed: {
    minNav() {
      let min = 0;
      if (this.selectedNavs.length) {
        min = this.selectedNavs.reduce((a, b) => Math.min(a, b));
      }
      return min;
    },
    maxNav() {
      let max = 0;
      if (this.selectedNavs.length) {
        max = this.selectedNavs.reduce((a, b) => Math.max(a, b));
      }
      return max;
    },
    softMinNav() {
      return this.minNav - 0.000001 * this.minNav;
    },
    softMaxNav() {
      return this.maxNav + 0.000001 * this.maxNav;
    },
    lastDate() {
      if (this.navs.length) {
        return dayjs(this.navs[this.navs.length - 1].date).format('DD MMMM YYYY');
      }
      return '';
    },
    firstDate() {
      if (this.navs.length) {
        return dayjs(this.navs[0].date).format('DD MMMM YYYY');
      }
      return '';
    },
    chartId() {
      if (this.product) {
        return `js-bukareksa-price-chart-${this.product.id}`;
      }
      return '';
    },
  },
  watch: {
    range() {
      this.getNav();
    },
    product() {
      this.getNav();
    },
  },
  mounted() {
    if (this.product && this.product.id) {
      this.chart = Highcharts.chart(document.getElementById(this.chartId), this.navChartConfig);
      this.getNav();
    }
  },
  methods: {
    getNav() {
      const navParams = {
        id: this.product.id,
        date: dayjs().format('YYYY-MM-DD'),
        limit: this.range,
      };

      api.getProductNav(navParams).then(({ data }) => {
        this.navs = data.reverse();
        this.setupData();
        this.setupChart();
      });
    },

    setupData() {
      this.xAxis = [];
      this.selectedNavs = [];
      this.navs.forEach(nav => {
        this.xAxis.push(dayjs(nav.date).format('DD/MM'));
        this.selectedNavs.push(nav.value);
      });
      this.navChartConfig.xAxis.categories = this.xAxis;
      this.navChartConfig.series[0].data = this.selectedNavs;
      this.navChartConfig.series[0].name = this.product.name;
      this.navChartConfig.yAxis.min = this.softMinNav;
      this.navChartConfig.yAxis.max = this.softMaxNav;
    },

    setupChart() {
      this.$nextTick(() => this.chart.update(this.navChartConfig, true));
    },
  },
};
</script>
